export default __webpack_public_path__ + "static/media/shutterstock_481902994.54528bf5.webp";